import { KText } from '@/ui-library/components/text';
import { Center, Flex } from '@chakra-ui/react';

export const Range = ({ count = 10 }) => {
  const ranges = Array.from({ length: count }, (_, index) => index + 1);
  return (
    <Flex gap="12px" width="100%" cursor="not-allowed">
      {ranges?.map((range, index) => (
        <Center
          flex="1"
          py="8px"
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          key={index}
        >
          <KText size="md-medium">{range}</KText>
        </Center>
      ))}
    </Flex>
  );
};
